"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3374],{

/***/ 3210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59059);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57805);



var Container = function(props) {
    var colorMode = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .useColorMode */ .If)().colorMode;
    var bgColor = {
        light: "white",
        dark: "gray.900"
    };
    var color = {
        light: "black",
        dark: "white"
    };
    var style = {
        paddingTop: 90
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        direction: "column",
        alignItems: "stretch",
        justifyContent: "flex-start",
        textAlign: "left",
        bg: bgColor[colorMode],
        color: color[colorMode],
        style: style
    }, props));
};


/***/ }),

/***/ 71404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29815);
/* harmony import */ var _home_runner_work_rekening_frontend_rekening_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_runner_work_rekening_frontend_rekening_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_rekening_frontend_rekening_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6240);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48843);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85975);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(57805);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(645);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(17297);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(60155);
/* harmony import */ var chakra_react_select__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(65266);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68856);











var InviteUserModal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, session = param.session;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)("common").t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isBrowser = ref[0], setIsBrowser = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        username: "",
        email: "",
        role: "READER",
        groups: [],
        invitationId: "EMPTY"
    }), newUser = ref1[0], setNewUser = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(t("inviteUserElement.completeAllFields")), errorUserInvite = ref2[0], setErrorUserInvite = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isLoadingUserInvite = ref3[0], setIsLoadingUserInvite = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), groupsListOptions = ref4[0], setGroupsListOptions = ref4[1];
    var toast = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .useToast */ .pm)();
    var ref5 = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .useDisclosure */ .qY)(), isRolesOpen = ref5.isOpen, onRolesOpen = ref5.onOpen, onRolesClose = ref5.onClose;
    var api_url = "https://api.rekening.de";
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setIsBrowser(true);
    }, []);
    var loadGroups = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_home_runner_work_rekening_frontend_rekening_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var groupsData, fetchData, data, groupsListTemp;
            return _home_runner_work_rekening_frontend_rekening_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.prev = 1;
                        fetchData = axios__WEBPACK_IMPORTED_MODULE_3___default().get("".concat(api_url, "/groups"), {
                            headers: {
                                Authorization: "Bearer ".concat(session.accessToken)
                            }
                        });
                        _ctx.next = 5;
                        return fetchData;
                    case 5:
                        data = _ctx.sent;
                        if (data.status != 403 && data.status != 500) {
                            groupsData = data.data;
                        }
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return");
                    case 12:
                        groupsListTemp = [];
                        groupsData.map(function(singleGroup) {
                            groupsListTemp.push({
                                label: singleGroup.title,
                                value: singleGroup._id
                            });
                        });
                        setGroupsListOptions((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(groupsListTemp));
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    9
                ]
            ]);
        }));
        return function loadGroups() {
            return _ref.apply(this, arguments);
        };
    }();
    react__WEBPACK_IMPORTED_MODULE_2__.useEffect(function() {
        loadGroups();
    }, [
        isOpen
    ]);
    var handleCloseClick = function(e) {
        e.preventDefault();
        onClose();
    };
    var userNotification = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_home_runner_work_rekening_frontend_rekening_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(title, subTitle, status) {
            return _home_runner_work_rekening_frontend_rekening_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        toast({
                            title: title,
                            description: subTitle,
                            status: status,
                            duration: 5000,
                            isClosable: true,
                            position: "bottom"
                        });
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function userNotification(title, subTitle, status) {
            return _ref.apply(this, arguments);
        };
    }();
    var createNewUser = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_home_runner_work_rekening_frontend_rekening_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var body, fetchData, response, response1;
            return _home_runner_work_rekening_frontend_rekening_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = newUser;
                        setIsLoadingUserInvite(true);
                        _ctx.next = 4;
                        return fetch("".concat(api_url, "/users/"), {
                            method: "POST",
                            headers: {
                                "Authorization": "Bearer ".concat(session.accessToken),
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(body)
                        });
                    case 4:
                        fetchData = _ctx.sent;
                        if (!(fetchData.status == 201)) {
                            _ctx.next = 15;
                            break;
                        }
                        _ctx.next = 8;
                        return fetchData.json();
                    case 8:
                        response = _ctx.sent;
                        setIsLoadingUserInvite(false);
                        onClose();
                        setNewUser({
                            username: "",
                            email: "",
                            role: "READER",
                            invitationId: "EMPTY",
                            groups: []
                        });
                        userNotification(t("inviteUserElement.inviteSuccess"), t("inviteUserElement.inviteDone", {
                            username: body.username
                        }), "success");
                        _ctx.next = 20;
                        break;
                    case 15:
                        _ctx.next = 17;
                        return fetchData.json();
                    case 17:
                        response1 = _ctx.sent;
                        setIsLoadingUserInvite(false);
                        if (response1.message.length == 1) {
                            userNotification("Error", response1["message"][0], "error");
                        } else {
                            userNotification("Error", response1["message"], "error");
                        }
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function createNewUser() {
            return _ref.apply(this, arguments);
        };
    }();
    var onChangeText = function(key, val) {
        var newUserTemp = newUser;
        if (key == "groups") {
            var tempArrayGroups = [];
            val.map(function(singleGroup) {
                tempArrayGroups.push(singleGroup.value);
            });
            val = tempArrayGroups;
        }
        newUserTemp[key] = val;
        setNewUser((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, newUserTemp));
    };
    var modalContent = isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Modal */ .u_, {
            isOpen: isOpen,
            onClose: onClose,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .ModalOverlay */ .ZA, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .ModalContent */ .hz, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .ModalHeader */ .xB, {
                            children: t("inviteUserElement.addUsers")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .ModalCloseButton */ .ol, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .ModalBody */ .fe, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .xv, {
                                    fontSize: "smaller",
                                    mb: "0",
                                    fontWeight: "bold",
                                    children: t("inviteUserElement.fullName")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .InputGroup */ .BZ, {
                                    mb: "3",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .InputLeftElement */ .Z8, {
                                            pointerEvents: "none",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_13__/* .IoPerson */ .J4e, {
                                                color: "#718096",
                                                fontSize: "1.3em"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Input */ .II, {
                                            value: newUser.username,
                                            onChange: function(evt) {
                                                return onChangeText("username", evt.target.value);
                                            },
                                            autoFocus: true,
                                            placeholder: t("inviteUserElement.fullNameRequired")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .xv, {
                                    mt: "3",
                                    fontSize: "smaller",
                                    mb: "0",
                                    fontWeight: "bold",
                                    children: t("inviteUserElement.businessMail")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .InputGroup */ .BZ, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .InputLeftElement */ .Z8, {
                                            pointerEvents: "none",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_13__/* .IoMail */ .GYo, {
                                                color: "#718096",
                                                fontSize: "1.3em"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Input */ .II, {
                                            value: newUser.email,
                                            onChange: function(evt) {
                                                return onChangeText("email", evt.target.value);
                                            },
                                            type: "email",
                                            placeholder: t("inviteUserElement.businessMail")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .xv, {
                                    mt: "3",
                                    fontSize: "smaller",
                                    mb: "0",
                                    fontWeight: "bold",
                                    children: t("inviteUserElement.userGroups")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(chakra_react_select__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    size: "sm",
                                    placeholder: t("inviteUserElement.selectGroups"),
                                    options: groupsListOptions,
                                    isMulti: true,
                                    onChange: function(groupList) {
                                        return onChangeText("groups", groupList);
                                    }
                                }),
                                !(newUser.email != "" && newUser.username != "" && newUser.groups.length != 0) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .xv, {
                                    style: {
                                        color: "red",
                                        marginTop: 10
                                    },
                                    children: errorUserInvite
                                }),
                                "cost" in session && session.cost.pricePerUser != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .xv, {
                                    fontSize: "small",
                                    style: {
                                        color: "grey",
                                        marginTop: 10
                                    },
                                    children: t("inviteUserElement.planCost", {
                                        cost: session.cost.pricePerUser / 100,
                                        unit: session.cost.subscriptionDuration
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .ModalFooter */ .mz, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_15__/* .Button */ .zx, {
                                    onClick: onClose,
                                    mr: 3,
                                    children: t("cancel")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_15__/* .Button */ .zx, {
                                    isLoading: isLoadingUserInvite,
                                    disabled: !(newUser.email != "" && newUser.username != "" && newUser.groups.length != 0),
                                    colorScheme: "rekening",
                                    onClick: function() {
                                        createNewUser();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_13__/* .IoPersonAdd */ .moY, {}),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .xv, {
                                            ml: "1",
                                            children: t("inviteUserElement.addUser")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }) : null;
    return modalContent;
};
/* harmony default export */ __webpack_exports__["Z"] = (InviteUserModal);


/***/ }),

/***/ 57115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_MenuElement; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(48843);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/toast/dist/index.esm.js + 3 modules
var dist_index_esm = __webpack_require__(6240);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/node_modules/@chakra-ui/layout/dist/index.esm.js + 1 modules
var layout_dist_index_esm = __webpack_require__(57805);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/avatar/dist/index.esm.js + 2 modules
var avatar_dist_index_esm = __webpack_require__(41378);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js + 3 modules
var button_dist_index_esm = __webpack_require__(17297);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/tooltip/dist/index.esm.js + 5 modules
var tooltip_dist_index_esm = __webpack_require__(53097);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/index.esm.js + 59 modules
var modal_dist_index_esm = __webpack_require__(85975);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/index.esm.js + 7 modules
var input_dist_index_esm = __webpack_require__(645);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/checkbox/dist/index.esm.js + 10 modules
var checkbox_dist_index_esm = __webpack_require__(29486);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var io5_index_esm = __webpack_require__(60155);
// EXTERNAL MODULE: ./node_modules/react-ga4/dist/index.js
var dist = __webpack_require__(49089);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/InviteUserModal.tsx
var InviteUserModal = __webpack_require__(71404);
// EXTERNAL MODULE: ./src/components/TutorialModal.tsx
var TutorialModal = __webpack_require__(36338);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/node_modules/@chakra-ui/spinner/dist/index.esm.js
var spinner_dist_index_esm = __webpack_require__(35975);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(33299);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(21190);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 169 modules
var motion = __webpack_require__(75814);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/node_modules/@chakra-ui/form-control/dist/index.esm.js
var form_control_dist_index_esm = __webpack_require__(66682);
;// CONCATENATED MODULE: ./src/components/CreateTeamModal.tsx








var CreateTeamModal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, accessToken = param.accessToken, onSuccess = param.onSuccess;
    var router = (0,next_router.useRouter)();
    var toast = (0,dist_index_esm/* useToast */.pm)();
    // update() was added in next-auth v4.22 — guard before calling
    var update = (0,next_auth_react.useSession)().update;
    var api_url = "https://api.rekening.de";
    var ref = (0,react.useState)(""), teamName = ref[0], setTeamName = ref[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)(""), error = ref2[0], setError = ref2[1];
    var handleClose = function() {
        setTeamName("");
        setError("");
        onClose();
    };
    var handleCreate = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var trimmed, res, msg, j;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        trimmed = teamName.trim();
                        if (trimmed) {
                            _ctx.next = 4;
                            break;
                        }
                        setError("Bitte gib einen Team-Namen ein.");
                        return _ctx.abrupt("return");
                    case 4:
                        if (!(trimmed.length < 2)) {
                            _ctx.next = 7;
                            break;
                        }
                        setError("Der Team-Name muss mindestens 2 Zeichen lang sein.");
                        return _ctx.abrupt("return");
                    case 7:
                        setIsLoading(true);
                        setError("");
                        _ctx.prev = 9;
                        _ctx.next = 12;
                        return fetch("".concat(api_url, "/users/me/teams"), {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "Authorization": "Bearer ".concat(accessToken)
                            },
                            body: JSON.stringify({
                                name: trimmed
                            })
                        });
                    case 12:
                        res = _ctx.sent;
                        if (res.ok) {
                            _ctx.next = 26;
                            break;
                        }
                        msg = "Team konnte nicht erstellt werden.";
                        _ctx.prev = 15;
                        _ctx.next = 18;
                        return res.json();
                    case 18:
                        j = _ctx.sent;
                        if (j === null || j === void 0 ? void 0 : j.message) msg = Array.isArray(j.message) ? j.message.join(", ") : String(j.message);
                        _ctx.next = 24;
                        break;
                    case 22:
                        _ctx.prev = 22;
                        _ctx.t0 = _ctx["catch"](15);
                    case 24:
                        setError(msg);
                        return _ctx.abrupt("return");
                    case 26:
                        // The backend already switched the active team to the newly created one.
                        // Refresh the NextAuth session so session.team_data reflects the new team
                        // BEFORE navigating to /setup — otherwise the wizard renders with the
                        // previously active team's data.
                        handleClose();
                        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                        if (!(typeof update === "function")) {
                            _ctx.next = 35;
                            break;
                        }
                        _ctx.next = 31;
                        return update();
                    case 31:
                        _ctx.next = 33;
                        return router.push("/setup");
                    case 33:
                        _ctx.next = 38;
                        break;
                    case 35:
                        _ctx.next = 37;
                        return router.push("/setup");
                    case 37:
                        router.reload();
                    case 38:
                        _ctx.next = 43;
                        break;
                    case 40:
                        _ctx.prev = 40;
                        _ctx.t1 = _ctx["catch"](9);
                        setError("Team konnte nicht erstellt werden. Bitte versuche es erneut.");
                    case 43:
                        _ctx.prev = 43;
                        setIsLoading(false);
                        return _ctx.finish(43);
                    case 46:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    9,
                    40,
                    43,
                    46
                ],
                [
                    15,
                    22
                ]
            ]);
        }));
        return function handleCreate() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* Modal */.u_, {
        isOpen: isOpen,
        onClose: handleClose,
        isCentered: true,
        size: "md",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalOverlay */.ZA, {
                backdropFilter: "blur(2px)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalContent */.hz, {
                borderRadius: "xl",
                boxShadow: "2xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalHeader */.xB, {
                        pb: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* HStack */.Ug, {
                            spacing: 3,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                                    w: 9,
                                    h: 9,
                                    borderRadius: "lg",
                                    bg: "rekening.500",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoBusinessOutline */.qmU, {
                                        color: "white",
                                        size: 18
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* VStack */.gC, {
                                    spacing: 0,
                                    align: "start",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                            fontSize: "md",
                                            fontWeight: "bold",
                                            children: "Neues Team erstellen"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                            fontSize: "xs",
                                            color: "gray.500",
                                            fontWeight: "normal",
                                            children: "Du wirst automatisch Eigent\xfcmer und Admin"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalCloseButton */.ol, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalBody */.fe, {
                        pt: 2,
                        pb: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_control_dist_index_esm/* FormControl */.NI, {
                            isInvalid: !!error,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormLabel */.lX, {
                                    fontSize: "sm",
                                    fontWeight: "semibold",
                                    color: "gray.700",
                                    children: "Team-Name"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, {
                                    placeholder: "z.B. Acme GmbH",
                                    value: teamName,
                                    onChange: function(e) {
                                        setTeamName(e.target.value);
                                        if (error) setError("");
                                    },
                                    onKeyDown: function(e) {
                                        if (e.key === "Enter") handleCreate();
                                    },
                                    focusBorderColor: "rekening.500",
                                    borderRadius: "lg",
                                    size: "md",
                                    autoFocus: true
                                }),
                                error && /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormErrorMessage */.J1, {
                                    children: error
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalFooter */.mz, {
                        pt: 0,
                        gap: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                variant: "ghost",
                                onClick: handleClose,
                                size: "sm",
                                isDisabled: isLoading,
                                children: "Abbrechen"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                colorScheme: "rekening",
                                onClick: handleCreate,
                                size: "sm",
                                isLoading: isLoading,
                                loadingText: "Wird erstellt…",
                                isDisabled: !teamName.trim(),
                                children: "Team erstellen"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CreateTeamModal = (CreateTeamModal);

;// CONCATENATED MODULE: ./src/components/TeamSwitcherDropdown.tsx










var getInitials = function(name) {
    return name.split(/\s+/).slice(0, 2).map(function(w) {
        return w[0];
    }).join("").toUpperCase();
};
var TeamSwitcherDropdown = function(param) {
    var teams = param.teams, activeTeamName = param.activeTeamName, activeTeamId = param.activeTeamId, accessToken = param.accessToken;
    // update() was added in next-auth v4.22 — guard before calling
    var update = (0,next_auth_react.useSession)().update;
    var router = (0,next_router.useRouter)();
    var toast = (0,dist_index_esm/* useToast */.pm)();
    var refreshSession = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(typeof update === "function")) {
                            _ctx.next = 5;
                            break;
                        }
                        _ctx.next = 3;
                        return update();
                    case 3:
                        _ctx.next = 6;
                        break;
                    case 5:
                        {
                            router.reload();
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function refreshSession() {
            return _ref.apply(this, arguments);
        };
    }();
    var api_url = "https://api.rekening.de";
    // When the backend hasn't returned the teams array yet, synthesize a single
    // entry from the current active team so the dropdown always renders.
    var displayTeams = teams.length > 0 ? teams : activeTeamName ? [
        {
            _id: activeTeamId || "",
            name: activeTeamName,
            isActive: true,
            role: "",
            owner: false
        }
    ] : [];
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react.useState)(null), switchingTeamId = ref1[0], setSwitchingTeamId = ref1[1];
    var dropdownRef = (0,react.useRef)(null);
    var ref2 = (0,index_esm/* useDisclosure */.qY)(), isCreateOpen = ref2.isOpen, onCreateOpen = ref2.onOpen, onCreateClose = ref2.onClose;
    (0,react.useEffect)(function() {
        var handleClickOutside = function(e) {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            return document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    var handleSwitch = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(team) {
            var res, msg, j;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(team.isActive || switchingTeamId)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        setSwitchingTeamId(team._id);
                        setIsOpen(false);
                        _ctx.prev = 4;
                        _ctx.next = 7;
                        return fetch("".concat(api_url, "/users/me/switch-team/").concat(team._id), {
                            method: "PATCH",
                            headers: {
                                "Authorization": "Bearer ".concat(accessToken)
                            }
                        });
                    case 7:
                        res = _ctx.sent;
                        if (res.ok) {
                            _ctx.next = 21;
                            break;
                        }
                        msg = "Team-Wechsel fehlgeschlagen.";
                        _ctx.prev = 10;
                        _ctx.next = 13;
                        return res.json();
                    case 13:
                        j = _ctx.sent;
                        if (j === null || j === void 0 ? void 0 : j.message) msg = String(j.message);
                        _ctx.next = 19;
                        break;
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](10);
                    case 19:
                        toast({
                            title: "Fehler",
                            description: msg,
                            status: "error",
                            duration: 5000,
                            isClosable: true,
                            position: "bottom-left"
                        });
                        return _ctx.abrupt("return");
                    case 21:
                        _ctx.next = 23;
                        return refreshSession();
                    case 23:
                        toast({
                            title: "Team gewechselt",
                            description: 'Du arbeitest jetzt mit "'.concat(team.name, '".'),
                            status: "success",
                            duration: 3000,
                            isClosable: true,
                            position: "bottom-left"
                        });
                        _ctx.next = 29;
                        break;
                    case 26:
                        _ctx.prev = 26;
                        _ctx.t1 = _ctx["catch"](4);
                        toast({
                            title: "Fehler",
                            description: "Netzwerkfehler beim Team-Wechsel.",
                            status: "error",
                            duration: 5000,
                            isClosable: true,
                            position: "bottom-left"
                        });
                    case 29:
                        _ctx.prev = 29;
                        setSwitchingTeamId(null);
                        return _ctx.finish(29);
                    case 32:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    26,
                    29,
                    32
                ],
                [
                    10,
                    17
                ]
            ]);
        }));
        return function handleSwitch(team) {
            return _ref.apply(this, arguments);
        };
    }();
    var isSwitching = switchingTeamId !== null;
    var trigger = // Fixed height - never changes between collapsed and expanded sidebar state.
    // The team name is absolutely positioned (same pattern as .side-menu-user-info)
    // so it never contributes to the element's height.
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
        onClick: function() {
            return setIsOpen(function(v) {
                return !v;
            });
        },
        cursor: "pointer",
        h: "44px",
        position: "relative",
        borderRadius: "lg",
        border: "1px solid",
        borderColor: isOpen ? "rekening.500" : "gray.200",
        bg: isOpen ? "green.50" : "gray.50",
        transition: "all 0.2s",
        _hover: {
            borderColor: "rekening.500",
            bg: "green.50"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Flex */.kC, {
                position: "absolute",
                left: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                align: "center",
                justify: "center",
                w: 7,
                h: 7,
                borderRadius: "md",
                bg: "rekening.500",
                flexShrink: 0,
                children: isSwitching ? /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner_dist_index_esm/* Spinner */.$, {
                    size: "xs",
                    color: "white"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                    fontSize: "10px",
                    fontWeight: "bold",
                    color: "white",
                    lineHeight: 1,
                    children: getInitials(activeTeamName || "T")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                className: "side-menu-team-text",
                position: "absolute",
                left: "44px",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* VStack */.gC, {
                        spacing: 0,
                        align: "start",
                        overflow: "hidden",
                        flex: 1,
                        mr: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                fontSize: "xs",
                                color: "gray.400",
                                fontWeight: "bold",
                                textTransform: "uppercase",
                                lineHeight: 1,
                                whiteSpace: "nowrap",
                                children: "Team"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                fontSize: "sm",
                                fontWeight: "semibold",
                                color: "gray.800",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxW: "140px",
                                children: activeTeamName
                            })
                        ]
                    }),
                    isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChevronUp */.AZg, {
                        size: 14,
                        color: "#718096"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChevronDown */.CgR, {
                        size: 14,
                        color: "#718096"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
        ref: dropdownRef,
        position: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_dist_index_esm/* Tooltip */.u, {
                label: activeTeamName,
                placement: "right",
                hasArrow: true,
                openDelay: 300,
                children: trigger
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                children: isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                    initial: {
                        opacity: 0,
                        y: -6,
                        scale: 0.98
                    },
                    animate: {
                        opacity: 1,
                        y: 0,
                        scale: 1
                    },
                    exit: {
                        opacity: 0,
                        y: -6,
                        scale: 0.98
                    },
                    transition: {
                        duration: 0.15
                    },
                    style: {
                        position: "absolute",
                        top: "calc(100% + 6px)",
                        left: 0,
                        width: "240px",
                        zIndex: 2000
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                        bg: "white",
                        borderRadius: "xl",
                        boxShadow: "xl",
                        border: "1px solid",
                        borderColor: "gray.100",
                        overflow: "hidden",
                        py: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                fontSize: "10px",
                                fontWeight: "bold",
                                textTransform: "uppercase",
                                color: "gray.400",
                                px: 3,
                                pt: 2,
                                pb: 1,
                                letterSpacing: "wider",
                                children: "Deine Teams"
                            }),
                            displayTeams.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                                px: 3,
                                py: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                    fontSize: "sm",
                                    color: "gray.400",
                                    children: "Keine Teams gefunden"
                                })
                            }) : displayTeams.map(function(team) {
                                var isSwitchingThis = switchingTeamId === team._id;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                                    px: 3,
                                    py: "10px",
                                    cursor: team.isActive ? "default" : "pointer",
                                    bg: team.isActive ? "green.50" : "transparent",
                                    _hover: team.isActive ? {} : {
                                        bg: "gray.50"
                                    },
                                    onClick: function() {
                                        return handleSwitch(team);
                                    },
                                    transition: "background 0.15s",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* HStack */.Ug, {
                                        spacing: 3,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                                                w: 8,
                                                h: 8,
                                                borderRadius: "md",
                                                bg: team.isActive ? "rekening.500" : "gray.100",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                flexShrink: 0,
                                                children: isSwitchingThis ? /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner_dist_index_esm/* Spinner */.$, {
                                                    size: "xs",
                                                    color: team.isActive ? "white" : "gray.500"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                    fontSize: "11px",
                                                    fontWeight: "bold",
                                                    color: team.isActive ? "white" : "gray.500",
                                                    lineHeight: 1,
                                                    children: getInitials(team.name)
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* VStack */.gC, {
                                                spacing: 0,
                                                align: "start",
                                                flex: 1,
                                                overflow: "hidden",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                        fontSize: "sm",
                                                        fontWeight: team.isActive ? "semibold" : "medium",
                                                        color: team.isActive ? "rekening.600" : "gray.700",
                                                        noOfLines: 1,
                                                        children: team.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* HStack */.Ug, {
                                                        spacing: 1,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                                fontSize: "10px",
                                                                color: "gray.400",
                                                                textTransform: "uppercase",
                                                                fontWeight: "medium",
                                                                children: team.role
                                                            }),
                                                            team.owner && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                                        fontSize: "10px",
                                                                        color: "gray.300",
                                                                        children: "\xb7"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                                        fontSize: "10px",
                                                                        color: "gray.400",
                                                                        children: "Eigent\xfcmer"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            team.isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCheckmarkCircle */.cfq, {
                                                size: 16,
                                                color: "#1a5f3f"
                                            })
                                        ]
                                    })
                                }, team._id);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Divider */.iz, {
                                my: 1,
                                borderColor: "gray.100"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                                px: 3,
                                py: "10px",
                                cursor: "pointer",
                                _hover: {
                                    bg: "gray.50"
                                },
                                onClick: function() {
                                    setIsOpen(false);
                                    onCreateOpen();
                                },
                                transition: "background 0.15s",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* HStack */.Ug, {
                                    spacing: 3,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                                            w: 8,
                                            h: 8,
                                            borderRadius: "md",
                                            border: "1.5px dashed",
                                            borderColor: "gray.300",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            flexShrink: 0,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoAddCircleOutline */.RWZ, {
                                                size: 16,
                                                color: "#718096"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                            fontSize: "sm",
                                            fontWeight: "medium",
                                            color: "gray.600",
                                            children: "Neues Team erstellen"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CreateTeamModal, {
                isOpen: isCreateOpen,
                onClose: onCreateClose,
                accessToken: accessToken
            })
        ]
    });
};
/* harmony default export */ var components_TeamSwitcherDropdown = (TeamSwitcherDropdown);

// EXTERNAL MODULE: ./node_modules/react-countdown/dist/index.es.js
var index_es = __webpack_require__(98130);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 23 modules
var esm = __webpack_require__(68856);
// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(65934);
;// CONCATENATED MODULE: ./src/components/MenuElement.tsx









dist/* default.initialize */.ZP.initialize("G-0GRPP85B5D");







// Renderer callback with condition
var rendererTimer = function(param) {
    var hours = param.hours, minutes = param.minutes, seconds = param.seconds, completed = param.completed;
    if (completed) {
        // Render a completed state
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    } else {
        // Render a countdown
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                minutes,
                " min. ",
                seconds,
                " sec."
            ]
        });
    }
};
var MenuElement = function(param) {
    var sessionData = param.sessionData, openInvoice = param.openInvoice, onUpgradeOpen = param.onUpgradeOpen;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var ref16 = (0,index_esm/* useDisclosure */.qY)(), isUserOpne = ref16.isOpen, onUserOpen = ref16.onOpen, onUserClose = ref16.onClose;
    var ref17 = (0,index_esm/* useDisclosure */.qY)(), isTutorialOpen = ref17.isOpen, onTutorialOpen = ref17.onOpen, onTutorialClose = ref17.onClose;
    var ref18 = (0,index_esm/* useDisclosure */.qY)(), isInviteUserOpen = ref18.isOpen, onInviteUserOpen = ref18.onOpen, onInviteUserClose = ref18.onClose;
    var router = (0,next_router.useRouter)();
    var newUserAllDataAdded = false;
    var ref19 = (0,index_esm/* useDisclosure */.qY)(), isOpen = ref19.isOpen, onOpen = ref19.onOpen, onClose = ref19.onClose;
    var ref20 = (0,react.useState)(false), uploadInProgress = ref20[0], setUploadInProgress = ref20[1];
    var elementRef = (0,react.useRef)(null);
    var api_url = "https://api.rekening.de";
    var toast = (0,dist_index_esm/* useToast */.pm)();
    var ref21 = (0,react.useState)(0), tabIndex = ref21[0], setTabIndex = ref21[1];
    var ref22 = (0,react.useState)([]), tabArray = ref22[0], setTabArray = ref22[1];
    var ref23 = (0,react.useState)(0), pendingSuggestionsCount = ref23[0], setPendingSuggestionsCount = ref23[1];
    var ref24 = (0,react.useState)(false), hasUnreadNotifications = ref24[0], setHasUnreadNotifications = ref24[1];
    var ref25 = (0,react.useState)(true), isSignupDiscountVisible = ref25[0], setIsSignupDiscountVisible = ref25[1];
    // Profile modal (draft editing)
    var ref26 = (0,react.useState)(false), isProfileSaving = ref26[0], setIsProfileSaving = ref26[1];
    var ref27 = (0,react.useState)(false), isProfileLoading = ref27[0], setIsProfileLoading = ref27[1];
    var ref28 = (0,react.useState)(null), profileMe = ref28[0], setProfileMe = ref28[1];
    var ref29 = (0,react.useState)({
        username: "",
        profilePicture: "",
        profilePictureSignedUrl: "",
        notificationSettingsKey: null,
        notificationSettings: null
    }), profileDraft = ref29[0], setProfileDraft = ref29[1];
    var ref30 = (0,react.useState)(null), profileOriginal = ref30[0], setProfileOriginal = ref30[1];
    var ref31 = (0,react.useState)({}), profileOverride = ref31[0], setProfileOverride = ref31[1];
    var navigateToTab = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(pageName) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        router.push(pageName);
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function navigateToTab(pageName) {
            return _ref.apply(this, arguments);
        };
    }();
    var isActiveRoute = function(route) {
        if (router.pathname === route) return true;
        // Treat settings sub-pages (e.g. /settings/integrations/...) as part of /settings
        if (route === "/settings" && router.pathname.startsWith("/settings/")) return true;
        return false;
    };
    var userNotification = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(title, subTitle, status) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        toast({
                            title: title,
                            description: subTitle,
                            status: status,
                            duration: 5000,
                            isClosable: true,
                            position: "bottom-left"
                        });
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function userNotification(title, subTitle, status) {
            return _ref.apply(this, arguments);
        };
    }();
    var ProfilePictureUploadRef = (0,react.useRef)(null);
    var normalizeNotificationSettingsV2 = function(val) {
        if (!val || typeof val !== "object") return null;
        var channels = val.channels;
        var events = val.events;
        if (!channels || typeof channels !== "object") return null;
        if (typeof channels.inApp !== "boolean" || typeof channels.email !== "boolean") return null;
        if (!Array.isArray(events)) return null;
        return {
            channels: {
                inApp: !!channels.inApp,
                email: !!channels.email
            },
            events: events.filter(function(e) {
                return e && typeof e === "object" && typeof e.key === "string";
            }).map(function(e) {
                return {
                    key: String(e.key),
                    label: e.label != null ? String(e.label) : undefined,
                    description: e.description != null ? String(e.description) : undefined,
                    channels: {
                        inApp: !!(e.channels && typeof e.channels === "object" ? e.channels.inApp : false),
                        email: !!(e.channels && typeof e.channels === "object" ? e.channels.email : false)
                    }
                };
            })
        };
    };
    var detectNotificationSettings = function(user) {
        if (!user || typeof user !== "object") return {
            key: null,
            settings: null
        };
        var candidates = [
            "notificationSettings",
            "notificationPreferences",
            "notificationsSettings",
            "notificationsPreferences", 
        ];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = candidates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var val = user[key];
                var normalized = normalizeNotificationSettingsV2(val);
                if (normalized) return {
                    key: key,
                    settings: normalized
                };
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return {
            key: null,
            settings: null
        };
    };
    var openProfileModal = function() {
        var ref, ref1, ref2, ref3;
        // Open immediately for snappy UX, then load fresh data via /users/me
        onUserOpen();
        var fallbackUser = (sessionData === null || sessionData === void 0 ? void 0 : sessionData.user_data) || {};
        var fallbackDetected = detectNotificationSettings(fallbackUser);
        var fallbackDraft = {
            username: String(((ref = fallbackUser) === null || ref === void 0 ? void 0 : ref.username) || ""),
            profilePicture: String(((ref1 = fallbackUser) === null || ref1 === void 0 ? void 0 : ref1.profilePicture) || ""),
            profilePictureSignedUrl: String(((ref2 = fallbackUser) === null || ref2 === void 0 ? void 0 : ref2.profilePictureSignedUrl) || ((ref3 = fallbackUser) === null || ref3 === void 0 ? void 0 : ref3.profilePicture) || ""),
            notificationSettingsKey: fallbackDetected.key,
            notificationSettings: fallbackDetected.settings
        };
        setProfileMe({
            user_data: fallbackUser,
            team_data: sessionData === null || sessionData === void 0 ? void 0 : sessionData.team_data
        });
        setProfileOriginal(fallbackDraft);
        setProfileDraft(fallbackDraft);
        if (!(sessionData === null || sessionData === void 0 ? void 0 : sessionData.accessToken)) return;
        (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, ref2, ref3, res, msg, j, me, user, team, detected, draft;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsProfileLoading(true);
                        _ctx.prev = 1;
                        ;
                        _ctx.next = 5;
                        return fetch("".concat(api_url, "/users/me"), {
                            headers: {
                                "Authorization": "Bearer ".concat(sessionData.accessToken)
                            }
                        });
                    case 5:
                        res = _ctx.sent;
                        if (res.ok) {
                            _ctx.next = 19;
                            break;
                        }
                        msg = "Failed to load profile (".concat(res.status, ")");
                        _ctx.prev = 8;
                        _ctx.next = 11;
                        return res.json();
                    case 11:
                        j = _ctx.sent;
                        if (j === null || j === void 0 ? void 0 : j.message) msg = Array.isArray(j.message) ? j.message.join(", ") : String(j.message);
                        else if (j === null || j === void 0 ? void 0 : j.error) msg = String(j.error);
                        _ctx.next = 17;
                        break;
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](8);
                    case 17:
                        userNotification("Error", msg, "error");
                        return _ctx.abrupt("return");
                    case 19:
                        _ctx.next = 21;
                        return res.json();
                    case 21:
                        me = _ctx.sent;
                        user = (me === null || me === void 0 ? void 0 : me.user_data) || {};
                        team = (me === null || me === void 0 ? void 0 : me.team_data) || (sessionData === null || sessionData === void 0 ? void 0 : sessionData.team_data);
                        setProfileMe({
                            user_data: user,
                            team_data: team
                        });
                        detected = detectNotificationSettings(user);
                        draft = {
                            username: String(((ref = user) === null || ref === void 0 ? void 0 : ref.username) || ""),
                            profilePicture: String(((ref1 = user) === null || ref1 === void 0 ? void 0 : ref1.profilePicture) || ""),
                            profilePictureSignedUrl: String(((ref2 = user) === null || ref2 === void 0 ? void 0 : ref2.profilePictureSignedUrl) || ((ref3 = user) === null || ref3 === void 0 ? void 0 : ref3.profilePicture) || ""),
                            notificationSettingsKey: detected.key,
                            notificationSettings: detected.settings
                        };
                        setProfileOriginal(draft);
                        setProfileDraft(draft);
                        _ctx.next = 34;
                        break;
                    case 31:
                        _ctx.prev = 31;
                        _ctx.t1 = _ctx["catch"](1);
                        userNotification("Error", "Network error while loading profile.", "error");
                    case 34:
                        _ctx.prev = 34;
                        setIsProfileLoading(false);
                        return _ctx.finish(34);
                    case 37:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    31,
                    34,
                    37
                ],
                [
                    8,
                    15
                ]
            ]);
        }))();
    };
    var uploadProPic = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            var returnOnlyData, formData, fetchData, response, ref, ref1, imageURL, imageURLSigned, userId, saveRes, saveJson, msg, updatedUser, savedProfilePicture, savedSignedUrl, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        returnOnlyData = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                        if (returnOnlyData == false) {
                            setUploadInProgress(true);
                        }
                        formData = new FormData();
                        formData.append("file", data);
                        _ctx.next = 6;
                        return fetch((0,url/* withInvoiceQueueConsumerTarget */.r)("".concat(api_url, "/files/upload/?disableAi=true")), {
                            headers: {
                                "Authorization": "Bearer ".concat(sessionData.accessToken)
                            },
                            credentials: "include",
                            method: "Post",
                            body: formData
                        });
                    case 6:
                        fetchData = _ctx.sent;
                        _ctx.next = 9;
                        return fetchData.json();
                    case 9:
                        response = _ctx.sent;
                        if (!(response.statusCode == 400 || response.statusCode == 500)) {
                            _ctx.next = 14;
                            break;
                        }
                        userNotification("Upload error", "Only PDF, PNG & JPG are allowed", "error");
                        setUploadInProgress(false);
                        return _ctx.abrupt("return");
                    case 14:
                        if (!(response && typeof response === "object" && "imageUrl" in response)) {
                            _ctx.next = 39;
                            break;
                        }
                        ;
                        imageURL = String(response.imageUrl || "");
                        imageURLSigned = String(response.imageUrlSigned || imageURL);
                        setProfileDraft(function(prev) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                profilePicture: imageURL,
                                profilePictureSignedUrl: imageURLSigned
                            });
                        });
                        userId = (profileMe === null || profileMe === void 0 ? void 0 : (ref = profileMe.user_data) === null || ref === void 0 ? void 0 : ref._id) || (sessionData === null || sessionData === void 0 ? void 0 : (ref1 = sessionData.user_data) === null || ref1 === void 0 ? void 0 : ref1._id);
                        if (userId) {
                            _ctx.next = 24;
                            break;
                        }
                        {
                            userNotification("Upload warning", "Image uploaded, but could not save it to your profile. Please reopen the profile popup and try again.", "warning");
                        }
                        _ctx.next = 37;
                        break;
                    case 24:
                        _ctx.next = 26;
                        return fetch("".concat(api_url, "/users/").concat(userId), {
                            method: "PATCH",
                            headers: {
                                "Authorization": "Bearer ".concat(sessionData.accessToken),
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                profilePicture: imageURL
                            })
                        });
                    case 26:
                        saveRes = _ctx.sent;
                        saveJson = null;
                        _ctx.prev = 28;
                        _ctx.next = 31;
                        return saveRes.json();
                    case 31:
                        saveJson = _ctx.sent;
                        _ctx.next = 36;
                        break;
                    case 34:
                        _ctx.prev = 34;
                        _ctx.t0 = _ctx["catch"](28);
                    case 36:
                        if (!saveRes.ok) {
                            msg = (saveJson === null || saveJson === void 0 ? void 0 : saveJson.message) ? Array.isArray(saveJson.message) ? saveJson.message.join(", ") : String(saveJson.message) : (saveJson === null || saveJson === void 0 ? void 0 : saveJson.error) ? String(saveJson.error) : "Image uploaded, but could not be saved to your profile.";
                            userNotification("Upload warning", msg, "warning");
                        } else {
                            updatedUser = (saveJson === null || saveJson === void 0 ? void 0 : saveJson.user_data) || saveJson || {};
                            savedProfilePicture = String((updatedUser === null || updatedUser === void 0 ? void 0 : updatedUser.profilePicture) || imageURL);
                            savedSignedUrl = String((updatedUser === null || updatedUser === void 0 ? void 0 : updatedUser.profilePictureSignedUrl) || imageURLSigned || savedProfilePicture);
                            setProfileDraft(function(prev) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                    profilePicture: savedProfilePicture,
                                    profilePictureSignedUrl: savedSignedUrl
                                });
                            });
                            setProfileOriginal(function(prev) {
                                return prev ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                    profilePicture: savedProfilePicture,
                                    profilePictureSignedUrl: savedSignedUrl
                                }) : prev;
                            });
                            setProfileOverride(function(prev) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                    profilePicture: savedProfilePicture,
                                    profilePictureSignedUrl: savedSignedUrl
                                });
                            });
                            setProfileMe(function(prev) {
                                return prev ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                    user_data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev.user_data, updatedUser), {
                                        profilePicture: savedProfilePicture,
                                        profilePictureSignedUrl: savedSignedUrl
                                    })
                                }) : prev;
                            });
                        }
                    case 37:
                        _ctx.next = 40;
                        break;
                    case 39:
                        {
                            userNotification("Upload error", "Upload response did not include an image URL.", "error");
                        }
                    case 40:
                        setUploadInProgress(false);
                    case 41:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    28,
                    34
                ]
            ]);
        }));
        return function uploadProPic(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var deleteProfilePicture = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setProfileDraft(function(prev) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                profilePicture: "",
                                profilePictureSignedUrl: ""
                            });
                        });
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function deleteProfilePicture() {
            return _ref.apply(this, arguments);
        };
    }();
    var isProfileDirty = function() {
        if (!profileOriginal) return false;
        if (profileDraft.username !== profileOriginal.username) return true;
        if (profileDraft.profilePicture !== profileOriginal.profilePicture) return true;
        if (profileDraft.notificationSettingsKey !== profileOriginal.notificationSettingsKey) return true;
        var a = profileDraft.notificationSettings;
        var b = profileOriginal.notificationSettings;
        if (!!a !== !!b) return true;
        if (a && b) {
            if (a.channels.inApp !== b.channels.inApp) return true;
            if (a.channels.email !== b.channels.email) return true;
            var mapA = {};
            var mapB = {};
            for(var i = 0; i < a.events.length; i++)mapA[a.events[i].key] = a.events[i].channels;
            for(var i1 = 0; i1 < b.events.length; i1++)mapB[b.events[i1].key] = b.events[i1].channels;
            var keys = Object.keys((0,_object_spread/* default */.Z)({}, mapA, mapB));
            for(var i2 = 0; i2 < keys.length; i2++){
                var k = keys[i2];
                var ca = mapA[k];
                var cb = mapB[k];
                if (!ca || !cb) return true;
                if (ca.inApp !== cb.inApp) return true;
                if (ca.email !== cb.email) return true;
            }
        }
        return false;
    }();
    var saveProfileDraft = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, userId, patch, eventsObj, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, ev, doPatch, ref2, res, json, merged, second, updatedUser, detected, refreshedDraft, msg;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (sessionData === null || sessionData === void 0 ? void 0 : sessionData.accessToken) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        if (profileOriginal) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 5:
                        setIsProfileSaving(true);
                        userId = (profileMe === null || profileMe === void 0 ? void 0 : (ref = profileMe.user_data) === null || ref === void 0 ? void 0 : ref._id) || (sessionData === null || sessionData === void 0 ? void 0 : (ref1 = sessionData.user_data) === null || ref1 === void 0 ? void 0 : ref1._id);
                        if (userId) {
                            _ctx.next = 11;
                            break;
                        }
                        userNotification("Error", "Missing user id (please reopen the profile popup).", "error");
                        setIsProfileSaving(false);
                        return _ctx.abrupt("return");
                    case 11:
                        patch = {
                            username: profileDraft.username,
                            profilePicture: profileDraft.profilePicture
                        };
                        if (!profileDraft.notificationSettings) {
                            _ctx.next = 32;
                            break;
                        }
                        eventsObj = {};
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _ctx.prev = 15;
                        for(_iterator = profileDraft.notificationSettings.events[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            ev = _step.value;
                            eventsObj[ev.key] = {
                                email: ev.channels.email,
                                inApp: ev.channels.inApp
                            };
                        }
                        _ctx.next = 23;
                        break;
                    case 19:
                        _ctx.prev = 19;
                        _ctx.t0 = _ctx["catch"](15);
                        _didIteratorError = true;
                        _iteratorError = _ctx.t0;
                    case 23:
                        _ctx.prev = 23;
                        _ctx.prev = 24;
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    case 26:
                        _ctx.prev = 26;
                        if (!_didIteratorError) {
                            _ctx.next = 29;
                            break;
                        }
                        throw _iteratorError;
                    case 29:
                        return _ctx.finish(26);
                    case 30:
                        return _ctx.finish(23);
                    case 31:
                        patch.notificationPreferences = {
                            channels: {
                                email: profileDraft.notificationSettings.channels.email,
                                inApp: profileDraft.notificationSettings.channels.inApp
                            },
                            events: eventsObj
                        };
                    case 32:
                        doPatch = function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(body) {
                                var res, json;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _ctx.next = 2;
                                            return fetch("".concat(api_url, "/users/").concat(userId), {
                                                method: "PATCH",
                                                headers: {
                                                    "Authorization": "Bearer ".concat(sessionData.accessToken),
                                                    "Content-Type": "application/json"
                                                },
                                                body: JSON.stringify(body)
                                            });
                                        case 2:
                                            res = _ctx.sent;
                                            json = null;
                                            _ctx.prev = 4;
                                            _ctx.next = 7;
                                            return res.json();
                                        case 7:
                                            json = _ctx.sent;
                                            _ctx.next = 12;
                                            break;
                                        case 10:
                                            _ctx.prev = 10;
                                            _ctx.t0 = _ctx["catch"](4);
                                        case 12:
                                            return _ctx.abrupt("return", {
                                                res: res,
                                                json: json
                                            });
                                        case 13:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee, null, [
                                    [
                                        4,
                                        10
                                    ]
                                ]);
                            }));
                            return function doPatch(body) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        _ctx.next = 35;
                        return doPatch(patch);
                    case 35:
                        ref2 = _ctx.sent;
                        res = ref2.res;
                        json = ref2.json;
                        if (res.ok) {
                            _ctx.next = 45;
                            break;
                        }
                        merged = (0,_object_spread/* default */.Z)({}, (profileMe === null || profileMe === void 0 ? void 0 : profileMe.user_data) || sessionData.user_data || {}, patch);
                        _ctx.next = 42;
                        return doPatch(merged);
                    case 42:
                        second = _ctx.sent;
                        res = second.res;
                        json = second.json;
                    case 45:
                        if (res.ok) {
                            userNotification("Saved", "Your profile has been updated.", "success");
                            setProfileOriginal(profileDraft);
                            setProfileOverride({
                                username: profileDraft.username,
                                profilePicture: profileDraft.profilePicture,
                                profilePictureSignedUrl: profileDraft.profilePictureSignedUrl
                            });
                            updatedUser = (json === null || json === void 0 ? void 0 : json.user_data) || json;
                            if (updatedUser && typeof updatedUser === "object" && updatedUser.notificationSettings) {
                                detected = detectNotificationSettings(updatedUser);
                                if (detected.settings) {
                                    refreshedDraft = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, profileDraft), {
                                        notificationSettingsKey: detected.key,
                                        notificationSettings: detected.settings
                                    });
                                    setProfileDraft(refreshedDraft);
                                    setProfileOriginal(refreshedDraft);
                                }
                                setProfileMe(function(prev) {
                                    return prev ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                        user_data: updatedUser
                                    }) : prev;
                                });
                            } else {
                                setProfileMe(function(prev) {
                                    return prev ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                        user_data: (0,_object_spread/* default */.Z)({}, prev.user_data || {}, patch)
                                    }) : prev;
                                });
                            }
                            onUserClose();
                        } else {
                            msg = json && (json.message || json.error) ? Array.isArray(json.message) ? json.message.join(", ") : String(json.message || json.error) : "Could not update profile.";
                            userNotification("Error", msg, "error");
                        }
                        setIsProfileSaving(false);
                    case 47:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    15,
                    19,
                    23,
                    31
                ],
                [
                    24,
                    ,
                    26,
                    30
                ]
            ]);
        }));
        return function saveProfileDraft() {
            return _ref.apply(this, arguments);
        };
    }();
    var makeSubscription = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var fetchData, fetchDataJson;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dist/* default.event */.ZP.event({
                            category: "Subscription",
                            action: "Open Buy Subscription Modal"
                        });
                        _ctx.next = 3;
                        return fetch("".concat(api_url, "/teams/subscribe/price_1N1Bg7Dbs3ThQfLD3rd3ksvx"), {
                            method: "POST",
                            headers: {
                                "Authorization": "Bearer ".concat(sessionData.accessToken),
                                "Content-Type": "application/json"
                            }
                        });
                    case 3:
                        fetchData = _ctx.sent;
                        _ctx.next = 6;
                        return fetchData.json();
                    case 6:
                        fetchDataJson = _ctx.sent;
                        if ("statusCode" in fetchDataJson) {} else {
                            window.location.href = fetchDataJson.url;
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function makeSubscription() {
            return _ref.apply(this, arguments);
        };
    }();
    react.useEffect(function() {
        var ref;
        // Early return if sessionData is not available
        if (!sessionData || !sessionData.user_data) {
            return;
        }
        var tabArrayTemp = [];
        if (sessionData["usage"] && sessionData["usage"]["used"] >= sessionData["usage"]["limit"]) {
            limitExceded = true;
        }
        var admin = ((ref = sessionData.user_data) === null || ref === void 0 ? void 0 : ref.role) == "ADMIN";
        var rights = sessionData.rights || [];
        // Dashboard is always first (index 0)
        if (admin || rights.includes("invoices")) {
            tabArrayTemp.push("/dashboard");
        }
        // Invoices/Rechnungen (index 1)
        if (admin || rights.includes("invoices")) {
            tabArrayTemp.push("/");
        }
        if (admin || rights.includes("travel-expenses")) {
        //tabArrayTemp.push("/?tabIndexMenu=1");
        }
        if (admin || rights.includes("statistics")) {
            tabArrayTemp.push("/analytics");
        }
        if (admin || rights.includes("invoices")) {
            tabArrayTemp.push("/transactions");
            tabArrayTemp.push("/booking-records");
        }
        if (admin || rights.includes("invoices")) {
            tabArrayTemp.push("/queue");
        }
        if (admin || rights.includes("invoices")) {
            tabArrayTemp.push("/suggestions");
        }
        if (admin || rights.includes("manage-users") || rights.includes("manage-budgets") || rights.includes("manage-groups") || rights.includes("manage-invoice-types") || rights.includes("manage-creditors")) {
            tabArrayTemp.push("/creditors");
        }
        if (admin || rights.includes("manage-clearing-accounts")) {
            tabArrayTemp.push("/clearing-accounts");
        }
        if (admin || rights.includes("manage-users") || rights.includes("manage-budgets") || rights.includes("manage-groups") || rights.includes("manage-invoice-types")) {
            tabArrayTemp.push("/settings");
            tabArrayTemp.push("/settings/integrations/google-drive");
        }
        // Profile page — available to all authenticated users
        tabArrayTemp.push("/profile");
        // Export (separate page, shown under Settings section)
        if (rights.includes("export-data")) {
            tabArrayTemp.push("/export");
        }
        var tabIndexTemp = tabArrayTemp.findIndex(function(e) {
            return e == router.pathname;
        });
        setTabIndex(tabIndexTemp);
        setTabArray(tabArrayTemp);
    }, [
        router.pathname,
        sessionData === null || sessionData === void 0 ? void 0 : sessionData.accessToken,
        sessionData === null || sessionData === void 0 ? void 0 : (ref = sessionData.user_data) === null || ref === void 0 ? void 0 : ref._id,
        sessionData === null || sessionData === void 0 ? void 0 : (ref1 = sessionData.user_data) === null || ref1 === void 0 ? void 0 : ref1.role,
        ((sessionData === null || sessionData === void 0 ? void 0 : sessionData.rights) || []).join(",")
    ]);
    // Fetch pending suggestions count
    react.useEffect(function() {
        var fetchPendingSuggestionsCount = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var response, data;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (sessionData === null || sessionData === void 0 ? void 0 : sessionData.accessToken) {
                                _ctx.next = 2;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 2:
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return fetch("".concat(api_url, "/suggestions/count"), {
                                headers: {
                                    "Authorization": "Bearer ".concat(sessionData.accessToken)
                                }
                            });
                        case 5:
                            response = _ctx.sent;
                            if (!response.ok) {
                                _ctx.next = 11;
                                break;
                            }
                            _ctx.next = 9;
                            return response.json();
                        case 9:
                            data = _ctx.sent;
                            setPendingSuggestionsCount(data.count || 0);
                        case 11:
                            _ctx.next = 16;
                            break;
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](2);
                            console.error("Error fetching suggestions count:", _ctx.t0);
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        13
                    ]
                ]);
            }));
            return function fetchPendingSuggestionsCount() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchPendingSuggestionsCount();
        // Refresh count every 30 seconds
        var interval = setInterval(fetchPendingSuggestionsCount, 30000);
        return function() {
            return clearInterval(interval);
        };
    }, [
        sessionData === null || sessionData === void 0 ? void 0 : sessionData.accessToken
    ]);
    // Fetch unread notifications indicator (dot)
    react.useEffect(function() {
        var fetchUnreadNotifications = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var params, response, data, items;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (sessionData === null || sessionData === void 0 ? void 0 : sessionData.accessToken) {
                                _ctx.next = 2;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 2:
                            _ctx.prev = 2;
                            params = new URLSearchParams({
                                page: "1",
                                pageSize: "1",
                                status: "unread"
                            });
                            _ctx.next = 6;
                            return fetch("".concat(api_url, "/notifications?").concat(params.toString()), {
                                headers: {
                                    "Authorization": "Bearer ".concat(sessionData.accessToken)
                                }
                            });
                        case 6:
                            response = _ctx.sent;
                            if (!response.ok) {
                                _ctx.next = 13;
                                break;
                            }
                            _ctx.next = 10;
                            return response.json();
                        case 10:
                            data = _ctx.sent;
                            items = Array.isArray(data) ? data : Array.isArray(data === null || data === void 0 ? void 0 : data.data) ? data.data : Array.isArray(data === null || data === void 0 ? void 0 : data.notifications) ? data.notifications : [];
                            setHasUnreadNotifications(((items === null || items === void 0 ? void 0 : items.length) || 0) > 0);
                        case 13:
                            _ctx.next = 18;
                            break;
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](2);
                            console.error("Error fetching notifications:", _ctx.t0);
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        15
                    ]
                ]);
            }));
            return function fetchUnreadNotifications() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchUnreadNotifications();
        var interval = setInterval(fetchUnreadNotifications, 30000);
        return function() {
            return clearInterval(interval);
        };
    }, [
        sessionData === null || sessionData === void 0 ? void 0 : sessionData.accessToken
    ]);
    var limitExceded = false;
    // Add null safety checks for sessionData
    if (sessionData != undefined && !("usage" in sessionData)) {
        window.location.href = "https://rekening.b2clogin.com/rekening.onmicrosoft.com/oauth2/v2.0/logout?p=B2C_1_APP_INTEGRATION_CONTENT_MICROSOFT_NEW&post_logout_redirect_uri=".concat("https://app.rekening.de", "/auth/signout");
    }
    if (sessionData != undefined && sessionData["usage"] && sessionData["usage"]["used"] >= sessionData["usage"]["limit"]) {
        limitExceded = true;
    }
    // Add defensive null safety checks
    var admin = (sessionData === null || sessionData === void 0 ? void 0 : (ref2 = sessionData.user_data) === null || ref2 === void 0 ? void 0 : ref2.role) == "ADMIN";
    var rights = (sessionData === null || sessionData === void 0 ? void 0 : sessionData.rights) || [];
    //SignUp Discount Timer
    // Erstelle ein Date-Objekt aus createdAt
    var countdownCreatedAt = new Date();
    try {
        var ref32;
        if (sessionData === null || sessionData === void 0 ? void 0 : (ref32 = sessionData.team_data) === null || ref32 === void 0 ? void 0 : ref32.createdAt) {
            countdownCreatedAt = new Date(sessionData.team_data.createdAt);
        }
    } catch (error) {}
    // Berechne die Endzeit des Countdowns (60 Minuten nach createdAt)
    var countdownEnd = countdownCreatedAt.getTime() + 60 * 60 * 1000 + 500000;
    // Aktuelle Zeit
    var countdownNow = new Date().getTime();
    // Berechne die vergangene Zeit in Millisekunden
    var countdownTimeElapsed = countdownNow - countdownCreatedAt.getTime();
    // Berechne verbleibende Zeit
    var countdownTimeLeft = countdownEnd - countdownNow;
    var _profilePictureSignedUrl, ref33, ref34, _username, _username1;
    var menuElement = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                position: "fixed",
                left: "0",
                top: "0",
                height: "100vh",
                zIndex: 1000,
                bg: "white",
                boxShadow: "lg",
                borderRadius: "0 8px 8px 0",
                transition: "all 0.3s ease",
                _hover: {
                    width: "280px"
                },
                width: "80px",
                overflow: "hidden",
                className: "side-menu",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* VStack */.gC, {
                    spacing: 0,
                    height: "100%",
                    align: "stretch",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                            p: 4,
                            borderBottom: "1px solid",
                            borderColor: "gray.200",
                            position: "relative",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* HStack */.Ug, {
                                spacing: 3,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_dist_index_esm/* Avatar */.qE, {
                                        size: "md",
                                        src: (ref34 = (ref33 = (_profilePictureSignedUrl = profileOverride.profilePictureSignedUrl) !== null && _profilePictureSignedUrl !== void 0 ? _profilePictureSignedUrl : profileOverride.profilePicture) !== null && ref33 !== void 0 ? ref33 : sessionData === null || sessionData === void 0 ? void 0 : (ref3 = sessionData.user_data) === null || ref3 === void 0 ? void 0 : ref3.profilePictureSignedUrl) !== null && ref34 !== void 0 ? ref34 : sessionData === null || sessionData === void 0 ? void 0 : (ref4 = sessionData.user_data) === null || ref4 === void 0 ? void 0 : ref4.profilePicture,
                                        name: (_username = profileOverride.username) !== null && _username !== void 0 ? _username : sessionData === null || sessionData === void 0 ? void 0 : (ref5 = sessionData.user_data) === null || ref5 === void 0 ? void 0 : ref5.username,
                                        onClick: function() {
                                            return router.push("/profile");
                                        },
                                        cursor: "pointer"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                                        className: "side-menu-user-info",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                fontSize: "xs",
                                                color: "gray.500",
                                                fontWeight: "bold",
                                                textTransform: "uppercase",
                                                children: sessionData === null || sessionData === void 0 ? void 0 : (ref6 = sessionData.user_data) === null || ref6 === void 0 ? void 0 : ref6.role
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                fontSize: "sm",
                                                fontWeight: "bold",
                                                noOfLines: 1,
                                                children: (_username1 = profileOverride.username) !== null && _username1 !== void 0 ? _username1 : sessionData === null || sessionData === void 0 ? void 0 : (ref7 = sessionData.user_data) === null || ref7 === void 0 ? void 0 : ref7.username
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        (sessionData === null || sessionData === void 0 ? void 0 : (ref8 = sessionData.team_data) === null || ref8 === void 0 ? void 0 : ref8.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                            px: 3,
                            py: 2,
                            borderBottom: "1px solid",
                            borderColor: "gray.100",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TeamSwitcherDropdown, {
                                teams: sessionData.teams || [],
                                activeTeamName: ((ref9 = sessionData.team_data) === null || ref9 === void 0 ? void 0 : ref9.name) || "",
                                activeTeamId: ((ref10 = sessionData.team_data) === null || ref10 === void 0 ? void 0 : ref10._id) || "",
                                accessToken: sessionData.accessToken
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* VStack */.gC, {
                            spacing: 0,
                            flex: 1,
                            align: "stretch",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                                    p: 2,
                                    position: "relative",
                                    mt: 3,
                                    pt: 6,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                            fontSize: "xs",
                                            color: "gray.500",
                                            fontWeight: "bold",
                                            textTransform: "uppercase",
                                            mb: 1,
                                            px: 2,
                                            className: "side-menu-section-header",
                                            children: "Main"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* VStack */.gC, {
                                            spacing: 1,
                                            align: "stretch",
                                            children: [
                                                (admin || rights.includes("invoices")) && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                    variant: "ghost",
                                                    colorScheme: "gray",
                                                    size: "sm",
                                                    justifyContent: "center",
                                                    onClick: function() {
                                                        return navigateToTab("/dashboard");
                                                    },
                                                    leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoGrid */.idP, {
                                                        size: 18
                                                    }),
                                                    _hover: {
                                                        bg: "gray.100"
                                                    },
                                                    _active: {
                                                        bg: isActiveRoute("/dashboard") ? "rekening.500" : "gray.200"
                                                    },
                                                    bg: isActiveRoute("/dashboard") ? "rekening.500" : "transparent",
                                                    color: isActiveRoute("/dashboard") ? "white" : "gray.700",
                                                    borderRadius: "md",
                                                    h: "40px",
                                                    className: "side-menu-button",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                        ml: 2,
                                                        fontWeight: "medium",
                                                        className: "side-menu-text",
                                                        children: t("components.menu.dashboard")
                                                    })
                                                }),
                                                (admin || rights.includes("invoices")) && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                    variant: "ghost",
                                                    colorScheme: "gray",
                                                    size: "sm",
                                                    justifyContent: "center",
                                                    onClick: function() {
                                                        return navigateToTab("/");
                                                    },
                                                    leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoReceipt */.Mpc, {
                                                        size: 18
                                                    }),
                                                    _hover: {
                                                        bg: "gray.100"
                                                    },
                                                    _active: {
                                                        bg: isActiveRoute("/") ? "rekening.500" : "gray.200"
                                                    },
                                                    bg: isActiveRoute("/") ? "rekening.500" : "transparent",
                                                    color: isActiveRoute("/") ? "white" : "gray.700",
                                                    borderRadius: "md",
                                                    h: "40px",
                                                    className: "side-menu-button",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                        ml: 2,
                                                        fontWeight: "medium",
                                                        className: "side-menu-text",
                                                        children: t("components.menu.invoices")
                                                    })
                                                }),
                                                (admin || rights.includes("invoices")) && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                    variant: "ghost",
                                                    colorScheme: "gray",
                                                    size: "sm",
                                                    justifyContent: "center",
                                                    onClick: function() {
                                                        return navigateToTab("/transactions");
                                                    },
                                                    leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoSwapHorizontal */.LGk, {
                                                        size: 18
                                                    }),
                                                    _hover: {
                                                        bg: "gray.100"
                                                    },
                                                    _active: {
                                                        bg: isActiveRoute("/transactions") ? "rekening.500" : "gray.200"
                                                    },
                                                    bg: isActiveRoute("/transactions") ? "rekening.500" : "transparent",
                                                    color: isActiveRoute("/transactions") ? "white" : "gray.700",
                                                    borderRadius: "md",
                                                    h: "40px",
                                                    className: "side-menu-button",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                        ml: 2,
                                                        fontWeight: "medium",
                                                        className: "side-menu-text",
                                                        children: t("components.menu.transactions")
                                                    })
                                                }),
                                                (admin || rights.includes("invoices")) && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                    variant: "ghost",
                                                    colorScheme: "gray",
                                                    size: "sm",
                                                    justifyContent: "center",
                                                    onClick: function() {
                                                        return navigateToTab("/booking-records");
                                                    },
                                                    leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoDocumentAttachOutline */.tJY, {
                                                        size: 18
                                                    }),
                                                    _hover: {
                                                        bg: "gray.100"
                                                    },
                                                    _active: {
                                                        bg: isActiveRoute("/booking-records") ? "rekening.500" : "gray.200"
                                                    },
                                                    bg: isActiveRoute("/booking-records") ? "rekening.500" : "transparent",
                                                    color: isActiveRoute("/booking-records") ? "white" : "gray.700",
                                                    borderRadius: "md",
                                                    h: "36px",
                                                    className: "side-menu-button",
                                                    sx: {
                                                        pl: "10px"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                        ml: 2,
                                                        fontWeight: "medium",
                                                        className: "side-menu-text",
                                                        children: t("components.menu.bookingRecords")
                                                    })
                                                }),
                                                (admin || rights.includes("invoices")) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_dist_index_esm/* Button */.zx, {
                                                    variant: "ghost",
                                                    colorScheme: "gray",
                                                    size: "sm",
                                                    justifyContent: "center",
                                                    onClick: function() {
                                                        return navigateToTab("/suggestions");
                                                    },
                                                    leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoBulb */.$Bi, {
                                                        size: 18
                                                    }),
                                                    _hover: {
                                                        bg: "gray.100"
                                                    },
                                                    _active: {
                                                        bg: isActiveRoute("/suggestions") ? "rekening.500" : "gray.200"
                                                    },
                                                    bg: isActiveRoute("/suggestions") ? "rekening.500" : "transparent",
                                                    color: isActiveRoute("/suggestions") ? "white" : "gray.700",
                                                    borderRadius: "md",
                                                    h: "40px",
                                                    className: "side-menu-button",
                                                    position: "relative",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                            ml: 2,
                                                            fontWeight: "medium",
                                                            className: "side-menu-text",
                                                            children: t("components.menu.suggestions")
                                                        }),
                                                        pendingSuggestionsCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Badge */.Ct, {
                                                            colorScheme: "red",
                                                            borderRadius: "full",
                                                            position: "absolute",
                                                            top: "2px",
                                                            right: "2px",
                                                            fontSize: "xs",
                                                            minW: "18px",
                                                            h: "18px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            children: pendingSuggestionsCount > 99 ? "99+" : pendingSuggestionsCount
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_dist_index_esm/* Button */.zx, {
                                                    variant: "ghost",
                                                    colorScheme: "gray",
                                                    size: "sm",
                                                    justifyContent: "center",
                                                    onClick: function() {
                                                        return navigateToTab("/notifications");
                                                    },
                                                    leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoNotifications */.IZE, {
                                                        size: 18
                                                    }),
                                                    _hover: {
                                                        bg: "gray.100"
                                                    },
                                                    _active: {
                                                        bg: isActiveRoute("/notifications") ? "rekening.500" : "gray.200"
                                                    },
                                                    bg: isActiveRoute("/notifications") ? "rekening.500" : "transparent",
                                                    color: isActiveRoute("/notifications") ? "white" : "gray.700",
                                                    borderRadius: "md",
                                                    h: "40px",
                                                    className: "side-menu-button",
                                                    position: "relative",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                            ml: 2,
                                                            fontWeight: "medium",
                                                            className: "side-menu-text",
                                                            children: t("components.menu.notifications")
                                                        }),
                                                        hasUnreadNotifications && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                                                            position: "absolute",
                                                            top: "10px",
                                                            right: "10px",
                                                            width: "8px",
                                                            height: "8px",
                                                            borderRadius: "full",
                                                            bg: "red.500"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                                    p: 2,
                                    position: "relative",
                                    pt: 6,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                            fontSize: "xs",
                                            color: "gray.500",
                                            fontWeight: "bold",
                                            textTransform: "uppercase",
                                            mb: 2,
                                            px: 2,
                                            className: "side-menu-section-header",
                                            children: "Verwaltung"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* VStack */.gC, {
                                            spacing: 1,
                                            align: "stretch",
                                            children: [
                                                (admin || rights.includes("manage-users") || rights.includes("manage-budgets") || rights.includes("manage-groups") || rights.includes("manage-invoice-types") || rights.includes("manage-creditors")) && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                    variant: "ghost",
                                                    colorScheme: "gray",
                                                    size: "sm",
                                                    justifyContent: "center",
                                                    onClick: function() {
                                                        return navigateToTab("/creditors");
                                                    },
                                                    leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoBusiness */.UQs, {
                                                        size: 18
                                                    }),
                                                    _hover: {
                                                        bg: "gray.100"
                                                    },
                                                    _active: {
                                                        bg: isActiveRoute("/creditors") ? "rekening.500" : "gray.200"
                                                    },
                                                    bg: isActiveRoute("/creditors") ? "rekening.500" : "transparent",
                                                    color: isActiveRoute("/creditors") ? "white" : "gray.700",
                                                    borderRadius: "md",
                                                    h: "40px",
                                                    className: "side-menu-button",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                        ml: 2,
                                                        fontWeight: "medium",
                                                        className: "side-menu-text",
                                                        children: t("components.menu.tradingPartners")
                                                    })
                                                }),
                                                (admin || rights.includes("manage-clearing-accounts")) && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                    variant: "ghost",
                                                    colorScheme: "gray",
                                                    size: "sm",
                                                    justifyContent: "center",
                                                    onClick: function() {
                                                        return navigateToTab("/clearing-accounts");
                                                    },
                                                    leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCash */.SG6, {
                                                        size: 18
                                                    }),
                                                    _hover: {
                                                        bg: "gray.100"
                                                    },
                                                    _active: {
                                                        bg: isActiveRoute("/clearing-accounts") ? "rekening.500" : "gray.200"
                                                    },
                                                    bg: isActiveRoute("/clearing-accounts") ? "rekening.500" : "transparent",
                                                    color: isActiveRoute("/clearing-accounts") ? "white" : "gray.700",
                                                    borderRadius: "md",
                                                    h: "40px",
                                                    className: "side-menu-button",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                        ml: 2,
                                                        fontWeight: "medium",
                                                        className: "side-menu-text",
                                                        children: t("components.menu.clearingAccounts")
                                                    })
                                                }),
                                                (admin || rights.includes("statistics")) && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                    variant: "ghost",
                                                    colorScheme: "gray",
                                                    size: "sm",
                                                    justifyContent: "center",
                                                    onClick: function() {
                                                        return navigateToTab("/analytics");
                                                    },
                                                    leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoBarChart */.kEG, {
                                                        size: 18
                                                    }),
                                                    _hover: {
                                                        bg: "gray.100"
                                                    },
                                                    _active: {
                                                        bg: isActiveRoute("/analytics") ? "rekening.500" : "gray.200"
                                                    },
                                                    bg: isActiveRoute("/analytics") ? "rekening.500" : "transparent",
                                                    color: isActiveRoute("/analytics") ? "white" : "gray.700",
                                                    borderRadius: "md",
                                                    h: "40px",
                                                    className: "side-menu-button",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                        ml: 2,
                                                        fontWeight: "medium",
                                                        className: "side-menu-text",
                                                        children: t("components.menu.analytics")
                                                    })
                                                }),
                                                (admin || rights.includes("invoices")) && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                    variant: "ghost",
                                                    colorScheme: "gray",
                                                    size: "sm",
                                                    justifyContent: "center",
                                                    onClick: function() {
                                                        return navigateToTab("/queue");
                                                    },
                                                    leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoTimer */.o6T, {
                                                        size: 18
                                                    }),
                                                    _hover: {
                                                        bg: "gray.100"
                                                    },
                                                    _active: {
                                                        bg: isActiveRoute("/queue") ? "rekening.500" : "gray.200"
                                                    },
                                                    bg: isActiveRoute("/queue") ? "rekening.500" : "transparent",
                                                    color: isActiveRoute("/queue") ? "white" : "gray.700",
                                                    borderRadius: "md",
                                                    h: "40px",
                                                    className: "side-menu-button",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                        ml: 2,
                                                        fontWeight: "medium",
                                                        className: "side-menu-text",
                                                        children: t("components.menu.queue")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                                    p: 2,
                                    position: "relative",
                                    pt: 6,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                            fontSize: "xs",
                                            color: "gray.500",
                                            fontWeight: "bold",
                                            textTransform: "uppercase",
                                            mb: 2,
                                            px: 2,
                                            className: "side-menu-section-header",
                                            children: "Settings"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* VStack */.gC, {
                                            spacing: 1,
                                            align: "stretch",
                                            children: [
                                                (admin || rights.includes("manage-users") || rights.includes("manage-budgets") || rights.includes("manage-groups") || rights.includes("manage-invoice-types")) && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                    variant: "ghost",
                                                    colorScheme: "gray",
                                                    size: "sm",
                                                    justifyContent: "center",
                                                    onClick: function() {
                                                        return navigateToTab("/settings");
                                                    },
                                                    leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoSettings */.CVU, {
                                                        size: 18
                                                    }),
                                                    _hover: {
                                                        bg: "gray.100"
                                                    },
                                                    _active: {
                                                        bg: isActiveRoute("/settings") ? "rekening.500" : "gray.200"
                                                    },
                                                    bg: isActiveRoute("/settings") ? "rekening.500" : "transparent",
                                                    color: isActiveRoute("/settings") ? "white" : "gray.700",
                                                    borderRadius: "md",
                                                    h: "40px",
                                                    className: "side-menu-button",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                        ml: 2,
                                                        fontWeight: "medium",
                                                        className: "side-menu-text",
                                                        children: t("components.menu.settings")
                                                    })
                                                }),
                                                rights.includes("export-data") && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                    variant: "ghost",
                                                    colorScheme: "gray",
                                                    size: "sm",
                                                    justifyContent: "center",
                                                    onClick: function() {
                                                        return navigateToTab("/export");
                                                    },
                                                    leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoDownload */.k$5, {
                                                        size: 18
                                                    }),
                                                    _hover: {
                                                        bg: "gray.100"
                                                    },
                                                    _active: {
                                                        bg: isActiveRoute("/export") ? "rekening.500" : "gray.200"
                                                    },
                                                    bg: isActiveRoute("/export") ? "rekening.500" : "transparent",
                                                    color: isActiveRoute("/export") ? "white" : "gray.700",
                                                    borderRadius: "md",
                                                    h: "40px",
                                                    className: "side-menu-button",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                        ml: 2,
                                                        fontWeight: "medium",
                                                        className: "side-menu-text",
                                                        children: t("components.menu.export")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* VStack */.gC, {
                            spacing: 1,
                            p: 2,
                            borderTop: "1px solid",
                            borderColor: "gray.200",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                    variant: "ghost",
                                    size: "sm",
                                    justifyContent: "center",
                                    onClick: function() {
                                        return onTutorialOpen();
                                    },
                                    leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoHelpCircle */.k$3, {
                                        size: 18
                                    }),
                                    _hover: {
                                        bg: "gray.50"
                                    },
                                    borderRadius: "md",
                                    h: "40px",
                                    className: "side-menu-button",
                                    colorScheme: "gray.100",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                        ml: 2,
                                        fontWeight: "medium",
                                        className: "side-menu-text",
                                        children: "Help"
                                    })
                                }),
                                (admin || rights.includes("manage-users")) && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                    variant: "ghost",
                                    size: "sm",
                                    justifyContent: "center",
                                    onClick: function() {
                                        return onInviteUserOpen();
                                    },
                                    leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoPersonAdd */.moY, {
                                        size: 18
                                    }),
                                    _hover: {
                                        bg: "gray.50"
                                    },
                                    borderRadius: "md",
                                    h: "40px",
                                    className: "side-menu-button",
                                    colorScheme: "gray.100",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                        ml: 2,
                                        fontWeight: "medium",
                                        className: "side-menu-text",
                                        children: "Invite User"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                    variant: "ghost",
                                    size: "sm",
                                    justifyContent: "center",
                                    onClick: function() {
                                        window.location.href = "https://rekening.b2clogin.com/rekening.onmicrosoft.com/oauth2/v2.0/logout?p=B2C_1_APP_INTEGRATION_CONTENT_MICROSOFT_NEW&post_logout_redirect_uri=".concat("https://app.rekening.de", "/auth/signout");
                                    },
                                    leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoExit */.MiK, {
                                        size: 18
                                    }),
                                    colorScheme: "red",
                                    _hover: {
                                        bg: "red.50"
                                    },
                                    borderRadius: "md",
                                    h: "40px",
                                    className: "side-menu-button",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                        ml: 2,
                                        fontWeight: "medium",
                                        color: "red.500",
                                        className: "side-menu-text",
                                        children: "Sign Out"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                position: "fixed",
                top: "20px",
                right: "20px",
                zIndex: 999,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* VStack */.gC, {
                    spacing: 2,
                    children: limitExceded && /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_dist_index_esm/* Tooltip */.u, {
                        label: t("components.menu.upgradePlan"),
                        placement: "left",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                            colorScheme: "rekening",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCart */.tqy, {}),
                            onClick: function() {
                                onUpgradeOpen();
                            },
                            "aria-label": "Upgrade Plan",
                            size: "lg",
                            isRound: true,
                            boxShadow: "lg"
                        })
                    })
                })
            }),
            limitExceded == true && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "subscription-banner",
                onClick: function() {
                    onUpgradeOpen();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Text */.xv, {
                        fontSize: "md",
                        children: [
                            t("components.menu.exededFreeUsage"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            t("components.menu.selectSubscriptionToContinue")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Center */.M5, {
                        mt: "3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCart */.tqy, {
                            fontSize: "22px"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* Modal */.u_, {
                isOpen: isUserOpne,
                onClose: onUserClose,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalOverlay */.ZA, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalContent */.hz, {
                        children: [
                            sessionData != undefined && /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalHeader */.xB, {
                                children: "Profile"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalCloseButton */.ol, {}),
                            sessionData != undefined && /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalBody */.fe, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                                        borderWidth: "1px",
                                        borderRadius: "lg",
                                        p: 4,
                                        bg: "gray.50",
                                        onDragOver: function(e) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                        },
                                        onDrop: function(e) {
                                            var ref, ref1;
                                            e.preventDefault();
                                            e.stopPropagation();
                                            var file = (ref = e.dataTransfer) === null || ref === void 0 ? void 0 : (ref1 = ref.files) === null || ref1 === void 0 ? void 0 : ref1[0];
                                            if (file) uploadProPic(file, false);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* HStack */.Ug, {
                                            spacing: 4,
                                            align: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_dist_index_esm/* Avatar */.qE, {
                                                    borderRadius: 12,
                                                    height: "72px",
                                                    width: "72px",
                                                    src: profileDraft.profilePictureSignedUrl || profileDraft.profilePicture || undefined,
                                                    name: profileDraft.username || (sessionData === null || sessionData === void 0 ? void 0 : (ref11 = sessionData.user_data) === null || ref11 === void 0 ? void 0 : ref11.username)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                                                    flex: "1",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                            fontWeight: "bold",
                                                            mb: "1",
                                                            children: t("components.menu.uploadPicture")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                            fontSize: "sm",
                                                            color: "gray.600",
                                                            mb: "2",
                                                            children: "Drag & drop an image here, or click to choose a file."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* HStack */.Ug, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                                    variant: "outline",
                                                                    onClick: function() {
                                                                        var ref, ref1;
                                                                        return (ref = ProfilePictureUploadRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.click) === null || ref1 === void 0 ? void 0 : ref1.call(ref);
                                                                    },
                                                                    isLoading: uploadInProgress,
                                                                    leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCloudUpload */.ZAz, {}),
                                                                    children: "Choose file"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                                    variant: "outline",
                                                                    colorScheme: "red",
                                                                    onClick: deleteProfilePicture,
                                                                    isDisabled: !profileDraft.profilePicture || uploadInProgress,
                                                                    leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoTrash */.VOs, {}),
                                                                    children: "Remove"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    ref: ProfilePictureUploadRef,
                                                                    style: {
                                                                        display: "none"
                                                                    },
                                                                    type: "file",
                                                                    accept: "image/*",
                                                                    onChange: function(e) {
                                                                        var ref, ref1;
                                                                        var file = (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.files) === null || ref1 === void 0 ? void 0 : ref1[0];
                                                                        if (file) uploadProPic(file, false);
                                                                        e.target.value = "";
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                                        mt: "4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                fontSize: "smaller",
                                                mb: "1",
                                                fontWeight: "bold",
                                                children: t("components.menu.name")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, {
                                                placeholder: "Type here...",
                                                value: profileDraft.username,
                                                onChange: function(e) {
                                                    return setProfileDraft(function(prev) {
                                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                            username: e.target.value
                                                        });
                                                    });
                                                },
                                                isDisabled: isProfileLoading
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                                        mt: "2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                fontSize: "smaller",
                                                mb: "1",
                                                fontWeight: "bold",
                                                children: "Team"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, {
                                                placeholder: "Type here...",
                                                value: (profileMe === null || profileMe === void 0 ? void 0 : (ref12 = profileMe.team_data) === null || ref12 === void 0 ? void 0 : ref12.name) || (sessionData === null || sessionData === void 0 ? void 0 : (ref13 = sessionData.team_data) === null || ref13 === void 0 ? void 0 : ref13.name) || "",
                                                readOnly: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                                        mt: "2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                fontSize: "smaller",
                                                mb: "1",
                                                fontWeight: "bold",
                                                children: "E-Mail"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, {
                                                placeholder: "Type here...",
                                                value: (profileMe === null || profileMe === void 0 ? void 0 : (ref14 = profileMe.user_data) === null || ref14 === void 0 ? void 0 : ref14.email) || (sessionData === null || sessionData === void 0 ? void 0 : (ref15 = sessionData.user_data) === null || ref15 === void 0 ? void 0 : ref15.email) || "",
                                                readOnly: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                                        mt: "4",
                                        borderWidth: "1px",
                                        borderRadius: "lg",
                                        p: 4,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                fontWeight: "bold",
                                                mb: "1",
                                                children: "Benachrichtigungseinstellungen"
                                            }),
                                            profileDraft.notificationSettingsKey && profileDraft.notificationSettings ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                        fontSize: "sm",
                                                        color: "gray.600",
                                                        mb: "3",
                                                        children: "Lege fest, welche Benachrichtigungen du in der App und per E-Mail bekommen moechtest."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                                                        mb: "4",
                                                        p: "3",
                                                        borderWidth: "1px",
                                                        borderRadius: "md",
                                                        bg: "white",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* HStack */.Ug, {
                                                            justify: "space-between",
                                                            align: "start",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                                            fontSize: "sm",
                                                                            fontWeight: "bold",
                                                                            children: "Benachrichtigungen erhalten"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                                            fontSize: "xs",
                                                                            color: "gray.500",
                                                                            children: "Wenn ein Kanal ausgeschaltet ist, werden die Themen darunter fuer diesen Kanal deaktiviert."
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* HStack */.Ug, {
                                                                    spacing: 6,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_dist_index_esm/* Checkbox */.XZ, {
                                                                            isChecked: !!profileDraft.notificationSettings.channels.inApp,
                                                                            isDisabled: isProfileLoading,
                                                                            onChange: function(e) {
                                                                                return setProfileDraft(function(prev) {
                                                                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                                        notificationSettings: prev.notificationSettings ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev.notificationSettings), {
                                                                                            channels: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev.notificationSettings.channels), {
                                                                                                inApp: e.target.checked
                                                                                            })
                                                                                        }) : prev.notificationSettings
                                                                                    });
                                                                                });
                                                                            },
                                                                            children: "App"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_dist_index_esm/* Checkbox */.XZ, {
                                                                            isChecked: !!profileDraft.notificationSettings.channels.email,
                                                                            isDisabled: isProfileLoading,
                                                                            onChange: function(e) {
                                                                                return setProfileDraft(function(prev) {
                                                                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                                        notificationSettings: prev.notificationSettings ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev.notificationSettings), {
                                                                                            channels: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev.notificationSettings.channels), {
                                                                                                email: e.target.checked
                                                                                            })
                                                                                        }) : prev.notificationSettings
                                                                                    });
                                                                                });
                                                                            },
                                                                            children: "E-Mail"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* VStack */.gC, {
                                                        align: "stretch",
                                                        spacing: 2,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* HStack */.Ug, {
                                                                justify: "space-between",
                                                                px: "2",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                                            fontSize: "xs",
                                                                            color: "gray.500",
                                                                            fontWeight: "bold",
                                                                            children: "THEMA"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* HStack */.Ug, {
                                                                        spacing: 10,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                                                fontSize: "xs",
                                                                                color: "gray.500",
                                                                                fontWeight: "bold",
                                                                                children: "APP"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                                                fontSize: "xs",
                                                                                color: "gray.500",
                                                                                fontWeight: "bold",
                                                                                children: "E-MAIL"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            profileDraft.notificationSettings.events.map(function(ev) {
                                                                var ref, ref1;
                                                                var appTopicsDisabled = isProfileLoading || !((ref = profileDraft.notificationSettings) === null || ref === void 0 ? void 0 : ref.channels.inApp);
                                                                var emailTopicsDisabled = isProfileLoading || !((ref1 = profileDraft.notificationSettings) === null || ref1 === void 0 ? void 0 : ref1.channels.email);
                                                                var allTopicsDisabled = appTopicsDisabled && emailTopicsDisabled;
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                                                                    p: "3",
                                                                    borderWidth: "1px",
                                                                    borderRadius: "md",
                                                                    bg: allTopicsDisabled ? "gray.50" : "white",
                                                                    opacity: allTopicsDisabled ? 0.58 : 1,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* HStack */.Ug, {
                                                                        justify: "space-between",
                                                                        align: "start",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                                                                                pr: "4",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                                                        fontSize: "sm",
                                                                                        fontWeight: "bold",
                                                                                        children: ev.label || ev.key
                                                                                    }),
                                                                                    ev.description && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                                                        fontSize: "xs",
                                                                                        color: "gray.500",
                                                                                        children: ev.description
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Text */.xv, {
                                                                                        fontSize: "xs",
                                                                                        color: "gray.400",
                                                                                        mt: "1",
                                                                                        children: [
                                                                                            "Key: ",
                                                                                            ev.key
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* HStack */.Ug, {
                                                                                spacing: 10,
                                                                                pt: "1",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_dist_index_esm/* Checkbox */.XZ, {
                                                                                        isChecked: !!ev.channels.inApp,
                                                                                        isDisabled: appTopicsDisabled,
                                                                                        onChange: function(e) {
                                                                                            return setProfileDraft(function(prev) {
                                                                                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                                                    notificationSettings: prev.notificationSettings ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev.notificationSettings), {
                                                                                                        events: prev.notificationSettings.events.map(function(x) {
                                                                                                            return x.key === ev.key ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, x), {
                                                                                                                channels: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, x.channels), {
                                                                                                                    inApp: e.target.checked
                                                                                                                })
                                                                                                            }) : x;
                                                                                                        })
                                                                                                    }) : prev.notificationSettings
                                                                                                });
                                                                                            });
                                                                                        }
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_dist_index_esm/* Checkbox */.XZ, {
                                                                                        isChecked: !!ev.channels.email,
                                                                                        isDisabled: emailTopicsDisabled,
                                                                                        onChange: function(e) {
                                                                                            return setProfileDraft(function(prev) {
                                                                                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                                                    notificationSettings: prev.notificationSettings ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev.notificationSettings), {
                                                                                                        events: prev.notificationSettings.events.map(function(x) {
                                                                                                            return x.key === ev.key ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, x), {
                                                                                                                channels: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, x.channels), {
                                                                                                                    email: e.target.checked
                                                                                                                })
                                                                                                            }) : x;
                                                                                                        })
                                                                                                    }) : prev.notificationSettings
                                                                                                });
                                                                                            });
                                                                                        }
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                }, ev.key);
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                fontSize: "sm",
                                                color: "gray.500",
                                                children: "No notification settings are available for this account yet."
                                            })
                                        ]
                                    }),
                                    (admin || rights.includes("invite-users")) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                                        mt: "2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                fontSize: "smaller",
                                                mb: "1",
                                                fontWeight: "bold",
                                                children: t("components.menu.inviteNewUser")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_dist_index_esm/* Button */.zx, {
                                                width: "full",
                                                mr: "3",
                                                onClick: function() {
                                                    onOpen();
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoPersonAdd */.moY, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                                        ml: "1",
                                                        children: t("components.menu.inviteUser")
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Text */.xv, {
                                        fontSize: "0.8em",
                                        color: "gray.500",
                                        ml: "0",
                                        mt: "3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                href: "https://rekening.de/en-allgemeine-geschaftsbedingungen/",
                                                children: "Terms of Use"
                                            }),
                                            " | ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                href: "https://rekening.de/en-privacy-policy/",
                                                children: "Privacy Policy"
                                            }),
                                            " | ",
                                            t("components.menu.deleteAccount")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalFooter */.mz, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_dist_index_esm/* Button */.zx, {
                                        variant: "outline",
                                        mr: 3,
                                        onClick: function() {
                                            window.location.href = "https://rekening.b2clogin.com/rekening.onmicrosoft.com/oauth2/v2.0/logout?p=B2C_1_APP_INTEGRATION_CONTENT_MICROSOFT_NEW&post_logout_redirect_uri=".concat("https://app.rekening.de", "/auth/signout");
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoExit */.MiK, {
                                                style: {
                                                    marginRight: "5px"
                                                }
                                            }),
                                            t("components.menu.signOut")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                        onClick: onUserClose,
                                        variant: "ghost",
                                        mr: 3,
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                        colorScheme: "rekening",
                                        leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoSave */.qaA, {}),
                                        onClick: saveProfileDraft,
                                        isLoading: isProfileSaving,
                                        isDisabled: !isProfileDirty || !profileDraft.username,
                                        children: "Save changes"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TutorialModal/* default */.Z, {
                isOpen: isTutorialOpen,
                onClose: onTutorialClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InviteUserModal/* default */.Z, {
                isOpen: isInviteUserOpen,
                onClose: onInviteUserClose,
                session: sessionData
            }),
            countdownTimeLeft > 0 && isSignupDiscountVisible && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "signup-discount-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                        className: "signup-discount-close",
                        "aria-label": t("close"),
                        variant: "ghost",
                        color: "white",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCloseCircle */.R5A, {}),
                        onClick: function(e) {
                            e.preventDefault();
                            e.stopPropagation();
                            setIsSignupDiscountVisible(false);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Center */.M5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Heading */.X6, {
                            size: "md",
                            color: "white",
                            mt: "2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.ZP, {
                                date: countdownEnd,
                                renderer: rendererTimer,
                                onComplete: function() {
                                    countdownTimeLeft = 0;
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Center */.M5, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Heading */.X6, {
                                size: "sm",
                                color: "white",
                                style: {
                                    display: "inline"
                                },
                                children: t("components.menu.discount90")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Heading */.X6, {
                                size: "sm",
                                color: "white",
                                style: {
                                    display: "inline",
                                    marginLeft: "7px",
                                    marginRight: "7px",
                                    textDecoration: "underline",
                                    textDecorationStyle: "dotted"
                                },
                                children: [
                                    "SIGNUP90",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCopy */.On2, {
                                        style: {
                                            display: "inline",
                                            fontSize: "14",
                                            marginLeft: "2px",
                                            cursor: "pointer"
                                        },
                                        onClick: function() {
                                            navigator.clipboard.writeText("SIGNUP90").then(function() {
                                                userNotification(t("components.menu.copiedClipboard"), t("components.menu.successfullyCopied"), "success");
                                            }).catch(function(err) {
                                                console.error(t("components.menu.copyError"), err);
                                            });
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Heading */.X6, {
                                color: "white",
                                size: "sm",
                                style: {
                                    display: "inline"
                                },
                                children: t("components.menu.atCheckout")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Center */.M5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_dist_index_esm/* Button */.zx, {
                            mt: "3",
                            onClick: function() {
                                makeSubscription();
                                dist/* default.event */.ZP.event({
                                    category: "Subscription",
                                    action: "Claim Discount"
                                });
                            },
                            children: [
                                t("components.menu.claimDiscountNow"),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCaretForward */.ABF, {}),
                                " "
                            ]
                        })
                    })
                ]
            })
        ]
    });
    return menuElement;
};
/* harmony default export */ var components_MenuElement = (MenuElement);


/***/ }),

/***/ 36338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57805);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17297);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




var TutorialModal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose;
    var mailRequest = function mailRequest() {
        var recipient = "kontakt@rekening.de";
        var subject = encodeURIComponent("Rekening support request");
        var body = encodeURIComponent("");
        window.location.href = "mailto:".concat(recipient, "?subject=").concat(subject, "&body=").concat(body);
    };
    var classList = "custom-modal-tutorial-overlay ";
    if (isOpen) {
        classList += "open";
    }
    var menuElement = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classList,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                onClick: onClose,
                className: "custom-modal-tutorial-bg-overlay"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "custom-modal-tutorial",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6, {
                        size: "md",
                        children: "Welcome to rekening!"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6, {
                        size: "sm",
                        children: "In this tutorial you will learn how to use rekening"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                        className: "full-iframe",
                        src: "https://demo.arcade.software/6e01NFei6EOvCz3jxC0Y?embed",
                        loading: "lazy",
                        title: "Rekening Expense Dashboard"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "custom-modal-tutorial-footer",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                                onClick: function() {
                                    mailRequest();
                                },
                                mr: "2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_4__/* .IoHelpCircle */ .k$3, {
                                        color: "black"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                        color: "black",
                                        ml: "1",
                                        children: "Create Support Request"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                                onClick: onClose,
                                colorScheme: "rekening",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_4__/* .IoCheckmarkCircle */ .cfq, {
                                        color: "black"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                        color: "black",
                                        ml: "1",
                                        children: "Done & Close Tutorial"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
    return menuElement;
};
/* harmony default export */ __webpack_exports__["Z"] = (TutorialModal);


/***/ }),

/***/ 71589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useProtectedSession; }
/* harmony export */ });
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33299);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



function useProtectedSession() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24;
    var ref25 = (0,next_auth_react__WEBPACK_IMPORTED_MODULE_0__.useSession)({
        required: false
    }), session = ref25.data, status = ref25.status;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var hasRedirectedRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        // Only redirect if we're sure the user is not authenticated (not loading)
        // and there's a critical error or no session at all
        var criticalErrors = [
            "RefreshAccessTokenError",
            "Unauthorized"
        ];
        // Don't redirect during loading state - wait for session to initialize
        if (status === "loading") {
            return;
        }
        // Only redirect if unauthenticated AND not currently on auth pages
        if (status === "unauthenticated" && !hasRedirectedRef.current) {
            var currentPath = router.pathname;
            var isAuthPage = (currentPath === null || currentPath === void 0 ? void 0 : currentPath.startsWith("/auth")) || (currentPath === null || currentPath === void 0 ? void 0 : currentPath.startsWith("/signup")) || currentPath === "/login" || currentPath === "/forgot-password";
            if (!isAuthPage) {
                console.log("User is not authenticated, redirecting to login");
                hasRedirectedRef.current = true;
                router.push("/auth/signin");
            }
            return;
        }
        // Reset redirect flag if user becomes authenticated
        if (status === "authenticated") {
            hasRedirectedRef.current = false;
        }
        // Handle critical errors only if authenticated (session exists but has error)
        if (status === "authenticated" && (session === null || session === void 0 ? void 0 : session.error) && typeof session.error === "string" && criticalErrors.includes(session.error) && !hasRedirectedRef.current) {
            console.log("Critical session error, redirecting to login:", session.error);
            hasRedirectedRef.current = true;
            router.push("/auth/signin");
        }
    }, [
        status,
        session === null || session === void 0 ? void 0 : session.error,
        router
    ]);
    // Return session with proper typing and null safety
    if (status === "loading") {
        return {
            session: null,
            status: "loading"
        };
    }
    if (status !== "authenticated" || !session) {
        return {
            session: null,
            status: "unauthenticated"
        };
    }
    var toOptionalNumber = function(value) {
        if (value === null || value === undefined || value === "") return undefined;
        if (typeof value === "number") return Number.isFinite(value) ? value : undefined;
        var n = Number(value);
        return Number.isFinite(n) ? n : undefined;
    };
    // Ensure session has required properties with fallbacks
    var protectedSession = {
        user: {
            id: ((ref = session.user) === null || ref === void 0 ? void 0 : ref.id) || "",
            email: ((ref1 = session.user) === null || ref1 === void 0 ? void 0 : ref1.email) || "",
            name: ((ref2 = session.user) === null || ref2 === void 0 ? void 0 : ref2.name) || ""
        },
        user_data: {
            _id: ((ref3 = session.user_data) === null || ref3 === void 0 ? void 0 : ref3._id) || "",
            username: ((ref4 = session.user_data) === null || ref4 === void 0 ? void 0 : ref4.username) || "",
            email: ((ref5 = session.user_data) === null || ref5 === void 0 ? void 0 : ref5.email) || "",
            role: ((ref6 = session.user_data) === null || ref6 === void 0 ? void 0 : ref6.role) || "USER",
            profilePicture: ((ref7 = session.user_data) === null || ref7 === void 0 ? void 0 : ref7.profilePicture) || "",
            profilePictureSignedUrl: ((ref8 = session.user_data) === null || ref8 === void 0 ? void 0 : ref8.profilePictureSignedUrl) || "",
            groups: ((ref9 = session.user_data) === null || ref9 === void 0 ? void 0 : ref9.groups) || []
        },
        team_data: {
            _id: ((ref10 = session.team_data) === null || ref10 === void 0 ? void 0 : ref10._id) || "",
            name: ((ref11 = session.team_data) === null || ref11 === void 0 ? void 0 : ref11.name) || "",
            createdAt: ((ref12 = session.team_data) === null || ref12 === void 0 ? void 0 : ref12.createdAt) || new Date().toISOString(),
            description: ((ref13 = session.team_data) === null || ref13 === void 0 ? void 0 : ref13.description) || "",
            country: ((ref14 = session.team_data) === null || ref14 === void 0 ? void 0 : ref14.country) || "",
            city: ((ref15 = session.team_data) === null || ref15 === void 0 ? void 0 : ref15.city) || "",
            zip: ((ref16 = session.team_data) === null || ref16 === void 0 ? void 0 : ref16.zip) || "",
            street: ((ref17 = session.team_data) === null || ref17 === void 0 ? void 0 : ref17.street) || "",
            vatId: ((ref18 = session.team_data) === null || ref18 === void 0 ? void 0 : ref18.vatId) || "",
            advisorNumber: toOptionalNumber((ref19 = session.team_data) === null || ref19 === void 0 ? void 0 : ref19.advisorNumber),
            clientNumber: toOptionalNumber((ref20 = session.team_data) === null || ref20 === void 0 ? void 0 : ref20.clientNumber),
            users: ((ref21 = session.team_data) === null || ref21 === void 0 ? void 0 : ref21.users) || []
        },
        accessToken: session.accessToken || "",
        refreshToken: session.refreshToken || "",
        rights: session.rights || [],
        usage: {
            used: ((ref22 = session.usage) === null || ref22 === void 0 ? void 0 : ref22.used) || 0,
            limit: ((ref23 = session.usage) === null || ref23 === void 0 ? void 0 : ref23.limit) || 0,
            users: typeof ((ref24 = session.usage) === null || ref24 === void 0 ? void 0 : ref24.users) === "number" ? session.usage.users : undefined
        },
        cost: session.cost || {},
        teams: session.teams || [],
        error: session.error
    };
    return {
        session: protectedSession,
        status: "authenticated"
    };
}


/***/ }),

/***/ 65934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ withInvoiceQueueConsumerTarget; }
/* harmony export */ });
/* provided dependency */ var process = __webpack_require__(83454);
/**
 * Conditionally appends the `INVOICE_QUEUE_CONSUMER_TARGET` query param to a URL.
 *
 * This is mainly used for upload endpoints so backend components can route work
 * to a specific consumer (e.g. `local`) during development.
 */ function withInvoiceQueueConsumerTarget(url) {
    var _NEXT_PUBLIC_INVOICE_QUEUE_CONSUMER_TARGET;
    // In Next.js, only NEXT_PUBLIC_* env vars are available in the browser bundle.
    // We support both names to be resilient across environments/build setups.
    var target = (_NEXT_PUBLIC_INVOICE_QUEUE_CONSUMER_TARGET = process.env.NEXT_PUBLIC_INVOICE_QUEUE_CONSUMER_TARGET) !== null && _NEXT_PUBLIC_INVOICE_QUEUE_CONSUMER_TARGET !== void 0 ? _NEXT_PUBLIC_INVOICE_QUEUE_CONSUMER_TARGET : process.env.INVOICE_QUEUE_CONSUMER_TARGET;
    if (!target) return url;
    // Upload URLs in this codebase are typically absolute (api_url + path).
    // If a relative URL ever slips through, fall back to a dummy base and then
    // return the original relative part.
    try {
        var parsed = new URL(url);
        parsed.searchParams.set("INVOICE_QUEUE_CONSUMER_TARGET", String(target));
        return parsed.toString();
    } catch (e) {
        var base = "http://localhost";
        var parsed1 = new URL(url, base);
        parsed1.searchParams.set("INVOICE_QUEUE_CONSUMER_TARGET", String(target));
        return parsed1.toString().replace(base, "");
    }
}


/***/ })

}]);